<template>
  <el-config-provider :locale="locale">
    <div id="app" class="bg-gray-200" style="min-height: 100vh;">

    <!-- 글로벌 axios progress bar -->
    <app-progress-bar />

    <!-- GNB 네비게이션 영역 -->
    <div id="nav" class="py-2 px-4 bg-gray-200">
      <div class="container max-w-screen-lg mx-auto">
        <div class="flex justify-between ">
          <div class="p-2 mr-2 w-1/5">
            <b>Candleworks POS</b>
            <span v-if="user">{{ user.mb_emp_name }}({{ user.store_id }})</span>
          </div>
          <div class=" ml-auto mr-0 text-right w-4/5">
            <template v-if="user">
              <router-link
                v-for="item in visibleNavItems"
                :key="item.to"
                v-slot="{isActive, navigate}"
                :to="item.to"
                custom
              >
                <button
                  class="bg-gray-500 p-2 mx-2 rounded"
                  :class="{'router-link-active': isActive}"
                  @click="navigate"
                >{{ item.name }}</button>
              </router-link>
              <button class="bg-gray-500 p-2 mx-2 rounded"
                      @click="$store.dispatch('user/logout')"
              >로그아웃</button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- GNB 네비게이션 영역 종료 -->

    <!-- 콘텐츠 영역 -->
    <div class="container max-w-screen-lg mx-auto pb-4">
      <router-view/>
    </div>
    <!-- 콘텐츠 영역 종료 -->
    </div>
  </el-config-provider>
</template>

<script>
  import AppProgressBar from '@/components/AppProgressBar.vue'
  import ko from 'element-plus/es/locale/lang/ko'

  export default {
    name: 'App',
    components: {AppProgressBar},
    data() {
      return {
        locale: ko,
        navItems: [
          {name: '판매', to: '/sales'},
          {name: '정산', to: '/adjust'},
          {name: '발주', to: '/purchase'},
          {name: '재고', to: '/inventory'},
          {name: 'CS관리', to: '/customers'},
          {name: '고객', to: '/member', requiresSubCustomer: true},
          {name: '주소록', to: '/address'},
          {name: '공지사항', to: '/notice'},
          {name: '환경설정', to: '/config'},
        ],
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/user']
      },
      visibleNavItems() {
        return this.navItems.filter(item => {
          return !item.requiresSubCustomer || this.$config.get('hasSubCustomer')
        })
      },
    },
  }
</script>

<style lang="scss">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    //text-align: center;
    color: #2c3e50;
    min-width: 1024px;
  }

  #nav {
    text-align: left;
    /*padding: 15px;*/

    button {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-active {
        background-color: #42b983;
        color: white;
      }
    }
  }
</style>
